import React from "react";

import { Globo } from "../../globo";

import "./index.scss";

const OndeAtuamos = () => {
  return (
    <div className="onde-atuamos">
      <Globo />
    </div>
  );
};

export default OndeAtuamos;
